var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntroVisionIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2931_674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0195 61.0142V67.0001",
    stroke: "white",
    strokeWidth: 2.04385,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4297 67.0001V61.0142",
    stroke: "white",
    strokeWidth: 2.04385,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2656 66.9999V57.8294C23.2656 54.8058 25.717 52.3557 28.7393 52.3557H37.7054C40.7291 52.3557 43.1791 54.8071 43.1791 57.8294V66.9999",
    stroke: "white",
    strokeWidth: 2.04385,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0086 47.9129C36.4112 47.9129 39.1695 45.1546 39.1695 41.752C39.1695 38.3494 36.4112 35.5911 33.0086 35.5911C29.606 35.5911 26.8477 38.3494 26.8477 41.752C26.8477 45.1546 29.606 47.9129 33.0086 47.9129Z",
    stroke: "white",
    strokeWidth: 2.04385,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5977 61.0562V55.0703",
    stroke: "white",
    strokeWidth: 2.04385,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4375 61.0561V51.8856C5.4375 48.8619 7.88884 46.4119 10.9112 46.4119H19.8773C21.3361 46.4119 22.6621 46.9829 23.6431 47.9128",
    stroke: "white",
    strokeWidth: 2.04385,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2631 36.798C21.8083 33.4393 19.5275 30.2747 16.1689 29.7295C12.8103 29.1843 9.6456 31.4651 9.10042 34.8237C8.55524 38.1823 10.836 41.347 14.1946 41.8922C17.5532 42.4374 20.7179 40.1566 21.2631 36.798Z",
    stroke: "white",
    strokeWidth: 2.04385,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.69548 45.2291C2.13704 41.4799 1.27734 37.3679 1.27734 33.0567C1.27734 15.5051 15.523 1.27734 33.095 1.27734",
    stroke: "white",
    strokeWidth: 2.55481,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2891 25.4561C17.2192 12.1455 25.6999 1.27734 33.0974 1.27734",
    stroke: "white",
    strokeWidth: 2.55481,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5898 61.0562V55.0703",
    stroke: "white",
    strokeWidth: 2.04385,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7525 61.0563V51.8858C60.7525 48.8622 58.3011 46.4121 55.2788 46.4121H46.3127C44.8539 46.4121 43.5279 46.9831 42.5469 47.9131",
    stroke: "white",
    strokeWidth: 2.04385,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.997 41.8892C55.3557 41.344 57.6364 38.1793 57.0912 34.8207C56.546 31.462 53.3814 29.1813 50.0227 29.7265C46.6641 30.2717 44.3834 33.4363 44.9285 36.795C45.4737 40.1536 48.6384 42.4343 51.997 41.8892Z",
    stroke: "white",
    strokeWidth: 2.04385,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4933 45.2291C64.0517 41.4799 64.9114 37.3679 64.9114 33.0567C64.9114 15.5051 50.6658 1.27734 33.0938 1.27734",
    stroke: "white",
    strokeWidth: 2.55481,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9021 25.4561C48.9719 12.1455 40.4912 1.27734 33.0938 1.27734",
    stroke: "white",
    strokeWidth: 2.55481,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0938 1.41284L33.1129 29.8735",
    stroke: "white",
    strokeWidth: 2.55481,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.53906 18.4343H61.3733",
    stroke: "white",
    strokeWidth: 2.55481,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2931_674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.1901,
    height: 67,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroVisionIcon2);
export default __webpack_public_path__ + "static/media/intro_vision_icon2.4b0c0a9cf085bed24fa7ee6a74203b1b.svg";
export { ForwardRef as ReactComponent };